import Evaporate from 'evaporate'
import random from 'random-gen'
import baseURL from '../../Root/url'
import File from 'orionsoft-parts/lib/components/fields/File'

const config = {
  awsSignatureVersion: '2',
  signerUrl: `${baseURL}/sign_s3`,
  logging: false
}

config.aws_key = 'AKIA6H3TZKEWJI7G7ZM6'
config.bucket = 'tufirma-prod'
//console.log("Usando bucket: " + config.bucket)

const evaporate = new Evaporate(config)

const replaceS3Url = function(name) {
  //console.log("======== awsKey: " + name)
  return `https://s3.amazonaws.com/${config.bucket}/${name}`
}

const uploadFile = function({file, onProgress, onReady, onError}) {
  const id = random.alphaNum(10)
  const name = `${id}_${file.name}`
  console.log("======== file es " + JSON.stringify(file))
  var puntoAntes = name.lastIndexOf(".");
  let extension = name.substring(puntoAntes + 1);
  if(!extension){
    console.log("Sin extension");
    alert("Debe subir archivos tipo: jpg, jpeg, bmp");
    return;
  }
  extension = extension.toLocaleLowerCase();
  console.log("Extension: " + extension);
  
  let extensionesPermitidas = ["jpg", "jpeg", "bmp"];

  if( extensionesPermitidas.indexOf(extension) < 0 ){
    alert("Debe subir archivos tipo: jpg, jpeg, bmp");
    return;
  }  

  if(extension === 'png'){
      
  }

  evaporate.add({
    name: `static/${name}`,
    file,
    contentType: file.type,
    progress: onProgress,
    error: function(message) {
      console.log(message, 'error uploading file')
      onError(message)
    },
    complete: function(_xhr, awsKey) {
      console.log('ok04 upload')
      onReady({
        url: replaceS3Url(awsKey),
        meta: {s3Path: '/' + awsKey}
      })
    }
  })
}

const deleteFile = function({file, onReady, onError}) {
  console.log('no delete function')
}

export default {
  type: File,
  upload: uploadFile,
  delete: deleteFile
}



// WEBPACK FOOTER //
// ./src/App/helpers/fields/imageUpload.js